/**
 * Utility functions for text processing and markdown handling
 */

/**
 * Cleans itemText by removing all markdown formatting while preserving meaningful line breaks
 * @param text - The text to clean
 * @returns Cleaned text with markdown formatting removed and line breaks preserved where appropriate
 */
export const cleanItemText = (text: string): string => {
  if (!text) return '';
  
  let cleaned = text;
  
  // Remove leading and trailing whitespace and line breaks
  cleaned = cleaned.replace(/^[\s\n\r]+|[\s\n\r]+$/g, '');
  
  // Remove markdown headers (## and ###) but preserve their content
  cleaned = cleaned.replace(/^#{2,3}\s*\*\*(.*?)\*\*$/gm, '$1'); // ## **text** or ### **text**
  cleaned = cleaned.replace(/^#{2,3}\s*/gm, ''); // ## or ###
  
  // Remove horizontal rules completely
  cleaned = cleaned.replace(/^---+$/gm, '');
  
  // Remove bullet points (- at start of line) but keep the text
  cleaned = cleaned.replace(/^-\s*/gm, '');
  
  // Remove bold formatting (**text**)
  cleaned = cleaned.replace(/\*\*(.*?)\*\*/g, '$1');
  
  // Handle line breaks more intelligently:
  // 1. Remove empty lines (multiple consecutive line breaks)
  cleaned = cleaned.replace(/\n\s*\n\s*\n/g, '\n\n'); // Convert 3+ line breaks to 2
  cleaned = cleaned.replace(/\n\s*\n/g, '\n'); // Convert double line breaks to single
  
  // 2. Preserve single line breaks that come after text content
  // This keeps intentional line breaks while removing excessive whitespace
  cleaned = cleaned.replace(/\n\s+/g, '\n'); // Remove spaces after line breaks
  cleaned = cleaned.replace(/\s+\n/g, '\n'); // Remove spaces before line breaks
  
  // 3. Clean up multiple spaces within lines (but preserve line breaks)
  cleaned = cleaned.replace(/[^\S\n]+/g, ' '); // Replace multiple spaces/tabs with single space, but keep line breaks
  
  // Final trim
  cleaned = cleaned.trim();
  
  return cleaned;
};
